import { useUserHasBusinessSegment } from '@/Hooks/useUserHasBusinessSegment';
import { useMemo } from 'react';
import { LocalizationType } from '@/Enums';
import { LANGUAGE_SELECT_OPTIONS_MAP } from '@/Localization/constants';
import { useUserHasMarketSegment } from '@/Hooks/useUserHasMarketSegment';

const LANGUAGE_SELECT_OPTIONS = Object.values(LANGUAGE_SELECT_OPTIONS_MAP);

export function useLanguageSelectOptions(excludeServiceLanguage = false) {
  const isAdmin = useUserHasBusinessSegment();
  const isMarket = useUserHasMarketSegment();

  return useMemo(() => {
    return !excludeServiceLanguage && (isAdmin || isMarket)
      ? LANGUAGE_SELECT_OPTIONS
      : LANGUAGE_SELECT_OPTIONS.filter((el) => el.key !== LocalizationType.LA);
  }, [isAdmin, isMarket]);
}
